'use client'

import { FC } from 'react'
import styles from './styles.module.scss'
import { DynamicImage } from '../DynamicImage'
import { Colour, SectionPaddingDefault } from '../constants'
import { CmsVideo } from '../CardPanel/CardPanelTypes'
import { CmsPageSectionBase, CmsResponsiveImage } from '../ComposedPage/types'
import { Panel, PanelItem, PanelLayout } from '../Panel'
import cx from 'classnames'
import { CONTENT_TYPE_MP4 } from '../Blog/BlogPost/VideoAsset'
import { getContentfulAssetUrl } from '@/utils/contentfulAsset'

export interface CmsAppVideoSection extends CmsPageSectionBase {
  fields: CmsPageSectionBase['fields'] & {
    appVideo: CmsVideo
    frameImage: CmsResponsiveImage
    backgroundColour: Colour
    mobileFrameImage: CmsResponsiveImage
  }
}

export const AppVideoSection: FC<CmsAppVideoSection> = ({ fields }) => {
  const {
    backgroundColour,
    sectionPaddingTop,
    sectionPaddingBottom,
    frameImage,
    mobileFrameImage,
    appVideo,
  } = fields

  return (
    <Panel
      className={styles.appVideo}
      colour={Colour[backgroundColour]}
      layout={PanelLayout.full}
      short
    >
      <PanelItem
        className={cx(
          styles.item,
          styles[sectionPaddingTop || SectionPaddingDefault.TOP],
          styles[sectionPaddingBottom || SectionPaddingDefault.BOTTOM],
        )}
      >
        <div className={styles.content}>
          <div className={styles.frame}>
            <DynamicImage
              className={styles.frameImage}
              image={frameImage}
              loading="eager"
              width={frameImage.fields.file.details.image.width}
              height={frameImage.fields.file.details.image.height}
              sizes="(max-width: 720px) 0px, 100vw"
            />
            <DynamicImage
              className={styles.mobileFrameImage}
              image={mobileFrameImage}
              loading="eager"
              width={mobileFrameImage.fields.file.details.image.width}
              height={mobileFrameImage.fields.file.details.image.height}
              sizes="(max-width: 720px) 100vw, 0px"
            />
          </div>
          <div className={styles.video}>
            <video
              aria-hidden
              disablePictureInPicture
              autoPlay
              muted
              controls={false}
              loop
              controlsList="nodownload"
            >
              <source
                src={getContentfulAssetUrl(appVideo.fields.file.url)}
                type={CONTENT_TYPE_MP4}
              />
              <p className={styles.notSupported}>
                {
                  "Your browser doesn't support this video format. Try updating to a newer version."
                }
              </p>
            </video>
          </div>
        </div>
      </PanelItem>
    </Panel>
  )
}
